import React, { useState } from 'react'

import useFetch from 'hooks/useFetch'

import AssetInventoryContext from 'contexts/AssetInventoryContext'

import * as services from 'service'

const AssetInventoryProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [assetInventoryProps, setAssetInventoryProps] = useState({})
  const [assetInventoryCategoryProps, setAssetInventoryCategoryProps] =
    useState({})

  const assetInventoryCategoryId = assetInventoryProps?.assetInventoryCategoryId

  const {
    response: categoriesResponse,
    isLoading: loadingCategories,
    refresh: refreshCategories,
  } = useFetch(
    services.dponet.assetInventoryCategory.get,
    { ...assetInventoryCategoryProps },
    [assetInventoryCategoryProps],
  )

  const assetInventoryCategories =
    categoriesResponse?.data?.assetInventoryCategories || []

  const {
    response: inventoryResponse,
    isLoading: loadingInventories,
    refresh: refreshInventories,
  } = useFetch(
    services.dponet.assetInventory.get,
    { perPage: 1000000, ...assetInventoryProps },
    [assetInventoryProps],
    !!assetInventoryCategoryId,
  )

  const assetInventories = assetInventoryCategoryId
    ? inventoryResponse?.data?.assetInventories || []
    : []

  const requestRefreshing = refreshCategories || refreshInventories

  return (
    <AssetInventoryContext.Provider
      value={{
        assetInventories,
        assetInventoryCategories,
        loadingInventories,
        loadingCategories,
        refreshInventories,
        refreshCategories,
        setAssetInventoryProps,
        setAssetInventoryCategoryProps,
        isLoading,
        refresh: requestRefreshing,
        setIsLoading,
      }}
    >
      {children}
    </AssetInventoryContext.Provider>
  )
}

export default AssetInventoryProvider
